import { useState } from 'react';

export default function DateCounter() {
  const [count, setCount] = useState(0);
  const [step, setStep] = useState(1);
  const modifiedDate = modifyDate(new Date(), count).toDateString();

  function modifyDate(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function handleChange(value) {
    setStep(value);
  }
  function handleReset() {
    setCount(0);
    setStep(1);
  }
  return (
    <div className='date-container'>
      <div className='counter-set'>
        <div>
          {' '}
          <div>
            <input
              type='range'
              id='slider'
              name='slider'
              min='0'
              max='10'
              value={step}
              onChange={(e) => handleChange(Number(e.target.value))}
            />
            <span>{step}</span>
          </div>
          <div>
            <button onClick={() => setCount((c) => c - step)}>-</button>
            <input
              type='text'
              value={count}
              onChange={(e) => setCount(Number(e.target.value))}
            />
            <button onClick={() => setCount((c) => c + step)}>+</button>
          </div>
        </div>

        <button
          className={`button ${count !== 0 || step !== 1 ? 'active' : ''} `}
          onClick={() => handleReset()}
        >
          Reset
        </button>
      </div>
      <p>
        {new Date().toDateString() !== modifiedDate
          ? `${count} days from today is ${modifiedDate}`
          : `Today is ${modifiedDate}`}
      </p>
    </div>
  );
}
